export default "__VITE_ASSET__CJQk7$qX__"